import {FilterState} from '../reducers/filter'
import {ALL_LOCATIONS} from '../types'

export const getFilterButtonText = (state: FilterState, t: Function) => {
  const items = state.tags.filter(item => item !== ALL_LOCATIONS)

  if (state.location !== ALL_LOCATIONS) {
    items.unshift(state.location)
  }

  if (!items.length) {
    return t('schedulePlaces.mobileFilterButton')
  }

  return items.join(', ')
}
